
import React from 'react';
import { Button } from '@/components/ui/button';
import { NavigateFunction } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

export const renderFindYourVerseContent = (item: any, navigate: NavigateFunction) => {
  if (!item || !item.content) return <p>No content available</p>;

  if (item.content.text) {
    return (
      <div className="space-y-4">
        {item.content.reference && (
          <div>
            <h3 className="font-medium">Reference:</h3>
            <p>{item.content.reference}</p>
          </div>
        )}
        {item.content.text && (
          <div>
            <h3 className="font-medium">Text:</h3>
            <p className="italic">{item.content.text}</p>
          </div>
        )}
        {item.content.context && (
          <div>
            <h3 className="font-medium">Context:</h3>
            <p>{item.content.context}</p>
          </div>
        )}
        {item.content.commentary && (
          <div>
            <h3 className="font-medium">Commentary:</h3>
            <p className="whitespace-pre-line">{item.content.commentary}</p>
          </div>
        )}
        {item.content.guidance && (
          <div>
            <h3 className="font-medium">Guidance:</h3>
            <p className="whitespace-pre-line">{item.content.guidance}</p>
          </div>
        )}
        {item.content.prompt && (
          <div>
            <h3 className="font-medium">Original Prompt:</h3>
            <p>{item.content.prompt}</p>
          </div>
        )}
        <Button
          onClick={() => navigate(`/find-your-verse`)}
          className="mt-4"
        >
          Go to Find Your Verse Tool
        </Button>
      </div>
    );
  } else {
    return (
      <div className="space-y-4">
        <div>
          <h3 className="font-medium">Prompt:</h3>
          <p>{item.content.prompt || 'N/A'}</p>
        </div>
        {item.content.scriptures && Array.isArray(item.content.scriptures) && (
          <div className="space-y-4">
            <h3 className="font-medium">Scriptures:</h3>
            {item.content.scriptures.map((scripture: any, i: number) => (
              <Card key={i} className="border-heaven-gold/10">
                <CardHeader className="py-3">
                  <CardTitle className="text-md">{scripture.reference || `Scripture ${i+1}`}</CardTitle>
                  <CardDescription className="mt-2">{scripture.text || 'No text available'}</CardDescription>
                </CardHeader>
              </Card>
            ))}
          </div>
        )}
        <Button
          onClick={() => navigate(`/find-your-verse`)}
          className="mt-4"
        >
          Go to Find Your Verse Tool
        </Button>
      </div>
    );
  }
};
